import React from "react";
import { t } from "ttag";

import { useAppDispatch } from "../../reducers";
import { viewStackPop } from "../reducers";
import {
    assignBasket,
    loadCurrentlyAssistedBasket,
    loadCurrentlyAssistedCustomer,
} from "../thunks";
import { FormView } from "./abstract/FormView";

interface IProps {
    basketID: number;
    email: string;
}

export const BasketAssign = (props: IProps) => {
    const dispatch = useAppDispatch();

    return (
        <FormView
            submitLabel={t`Assign Basket`}
            fields={[
                {
                    label: t`Email Address`,
                    name: "email",
                    type: "email",
                },
            ]}
            initialValues={props}
            onSubmit={async (event, data) => {
                event.preventDefault();
                const email = data.email as string;
                try {
                    await dispatch(
                        assignBasket({ basketID: props.basketID, email }),
                    ).unwrap();
                } catch (err) {
                    console.error(err);
                    alert(t`Error! Could not assign basket.`);
                    return;
                }
                await Promise.all([
                    dispatch(loadCurrentlyAssistedCustomer()),
                    dispatch(loadCurrentlyAssistedBasket()),
                ]);
                dispatch(viewStackPop());
            }}
        />
    );
};
